import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatApiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail) && detail.length) {
    return detail
      .map((d) => {
        const field = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : "";
        const label = typeof field === "string" ? field.replace(/_/g, " ") : "";
        return label ? `${label}: ${d?.msg || "invalid"}` : d?.msg || "Invalid input";
      })
      .join(" · ");
  }
  if (detail && typeof detail === "object") return detail.msg || fallback;
  if (error?.message === "Network Error") return "Can't reach the server. Check your connection.";
  return fallback;
}
